import { sectionsSelectors } from './sections.selectors';
import { sectionsReducer } from './sections.reducer';
import { sectionsActions } from './sections.actions';

export const sections = {
  actions: sectionsActions,
  reducer: sectionsReducer,
  selectors: sectionsSelectors,
};
